import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { ARTIFACTS_LABEL } from './accountModel'
import { AGENT_FACES, DEFAULT_FACE } from './agentFaces'
import { AgentNameProvider } from './agentName'
import { PANEL_WIDTH } from './AgentSurface'
import { AvatarHandoffMock } from './AvatarHandoffMock'
import { FleetDesktopPlacement } from './FleetDesktopPlacement'
import { DESKTOP_WIDTH, MOBILE_WIDTH, OptionSection } from './OptionSection'
import { PlainMobilePlacement } from './PlainMobilePlacement'
import { ReactAppMock } from './ReactAppMock'

/** No mascot, no naming step: the agent answers to the brand. */
const PLAIN_NAME = 'Cai'

/** Option 5 — Option 3's two surfaces, with the agent left unnamed. */
export function PlainCaiOptionSection({
  shellClass,
  shellHeight,
}: {
  shellClass: string
  shellHeight: number
}) {
  const [notificationId, setNotificationId] = useState(0)

  return (
    <AgentNameProvider
      name={PLAIN_NAME}
      face={DEFAULT_FACE}
      faceOptions={AGENT_FACES}
      artifactsLabel={ARTIFACTS_LABEL}
    >
      <OptionSection
        title="Agent tabs"
        defaultOpen
        action={
          <Button size="sm" variant="outline" onClick={() => setNotificationId((id) => id + 1)}>
            Send a notification
          </Button>
        }
        panes={[
          {
            label: 'React app',
            width: PANEL_WIDTH,
            content: <ReactAppMock height={shellHeight} notified={notificationId > 0} connect blankChat />,
          },
          {
            label: 'Mobile web',
            width: MOBILE_WIDTH,
            content: <PlainMobilePlacement className={shellClass} notified={notificationId > 0} />,
          },
          {
            label: 'Desktop',
            width: DESKTOP_WIDTH,
            startsGroup: true,
            content: (
              <FleetDesktopPlacement
                notificationId={notificationId}
                className={shellClass}
                plainAgent
                cfoOnly
              />
            ),
          },
          {
            label: 'Avatar handoff',
            width: DESKTOP_WIDTH,
            startsGroup: true,
            content: <AvatarHandoffMock className={shellClass} />,
          },
        ]}
      />
    </AgentNameProvider>
  )
}
